module.exports = __webpack_public_path__ + "static/media/win-pic-dream-prize.40e069da.png";